import { themeColor } from '@hud/web-components/theme/colors';
import { xsBold, xsRegular } from '@hud/web-components/theme/typography';
import styled from 'styled-components';
import { ModuleIcon } from '@hud/web-components/ThirdParty/ModuleIcon';
import { LinkCell as LinkCellComponent } from '@hud/web-components/Table/Table';
import { ellipsisMixin } from '@hud/web-components/theme/utils';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';

const EntityIcon = styled(ModuleIcon)``;
export const StyledPopover = styled(LongContentPopover)`
`;

const LinkCell = styled(LinkCellComponent)`
  display: flex;
  gap: 8px;
  min-width: 0;
  align-items: center;
  & ${EntityIcon} {
    flex-shrink: 0;
  }
  & ${StyledPopover} {
    ${ellipsisMixin}
  }
`;

const FunctionPopover = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Signature = styled.div`
  ${xsBold}
`;

const FilePath = styled.div`
  ${xsBold}

  span:first-child {
    ${xsRegular}
    color: ${themeColor('textTertiary')};
  }
`;


export default { StyledPopover, FunctionPopover, LinkCell, Signature, FilePath, EntityIcon };